import { createTheme } from '@mui/material/styles';

/** Tema chiaro dai mockup: blu royal, superfici bianche, sfondo grigio-azzurro. */
export default createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1d4ed8', dark: '#1e40af' },
    success: { main: '#16a34a' },
    warning: { main: '#ea580c' },
    error:   { main: '#dc2626' },
    background: { default: '#f4f6fa', paper: '#ffffff' },
    text: { primary: '#0f172a', secondary: '#64748b' },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: `'Inter','Segoe UI',system-ui,-apple-system,sans-serif`,
    h6: { fontWeight: 800 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiPaper: { styleOverrides: { root: { boxShadow: '0 1px 3px rgba(15,23,42,.08)' } } },
    MuiChip:  { styleOverrides: { root: { fontWeight: 600 } } },
  },
});
